import { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next";

import { Input, SelectBox, ClassesDropdown, RichText, UploadForm } from '../Form'
import { TbMathXDivideY, TbMath } from "react-icons/tb";

import MathInput from './math/input';
import { AppContext } from "../../Context";

import Math0 from '../../assets/math/2.png'
import Math1 from '../../assets/math/1.png'
import Math2 from '../../assets/math/2.png'

import './css/pop.css'

export default function Math({ setOpen, Open, onChange, math }) {

    const { t } = useTranslation();
    console.log(math);
    
    const {successData, userinfo, options} = useContext(AppContext);
    const [open, setopen] = successData;

    const [values, setvalues] = useState([]);
    const [tab, settab] = useState(0);
    
    function getChanges(val) {

        let ck = values?.filter(r => r?.key == val?.key);
        if (!ck?.length) {
            setvalues(p => [...p, val]);
        } else {
            setvalues(p => [...p?.filter(r => r?.key != val?.key), val]);
        }
        
    }

    

    function save() {
        
        if (values?.length < 2) {
            setopen({ error: true, short: t("math_all_values") });
            return false;
        }

        if (tab == 1) {
            if (values?.length < 3) {
                setopen({ error: true, short: t("math_all_values") });
                return false;
            }
        }

        onChange({ type: Open, math:math, value:values });
        setOpen(false);
    }

    
    return (
        <div tabindex="-1" className='tiny_pop Img'>
            
            <div className='tiny_body'>

                {math == 0 && 
                    <>
                        <h3>{t("math_aljabra_1")}</h3>
                        <div className='mathPopBox'>
                            <nav className='tab'>
                                <a className={tab == 0 ? "ck" : "null"} onClick={() => settab(0)}><img style={{height:26,}} src={Math0} /></a>
                                <a className={tab == 1 ? "ck" : "null"} onClick={() => settab(1)} ><img style={{height:26,}} src={Math1} /></a>

                            </nav>
                        </div>

                        <div className='mathPopBody'>

                            <div className='mathAljabraBox'>
                                <div>
                                    <MathInput k={'x'} onChange={getChanges} placeholder="x" />
                                    <hr />
                                    <MathInput k={'y'} onChange={getChanges} placeholder="y" />
                                </div>
                                {tab == 1 && 
                                <>
                                    =    
                                    <MathInput k={'z'} onChange={getChanges} placeholder="z" /> 
                                </>}
                                    
                            </div>
                            
                        </div>
                    </>
                }

                {/* {math == 1 && 
                    <>
                        <h3>{t("math_aljabra_2")}</h3>
                        <div className='mathPopBox'>
                            <nav className='tab'>
                                <a className={tab == 0 ? "ck" : "null"} onClick={() => settab(0)}><img style={{height:26,}} src={Math0} /></a>
                                <a className={tab == 1 ? "ck" : "null"} onClick={() => settab(1)} ><img style={{height:26,}} src={Math1} /></a>

                            </nav>
                        </div>

                        <div className='mathPopBody'>

                            <div className='mathAljabraBox'>
                                <div>
                                    <MathInput k={'x'} onChange={getChanges} placeholder="x" />
                                    <hr />
                                    <MathInput k={'y'} onChange={getChanges} placeholder="y" />
                                </div>
                                {tab == 1 && 
                                <>
                                    =    
                                    <MathInput k={'z'} onChange={getChanges} placeholder="z" /> 
                                </>}
                                    
                            </div>
                            
                        </div>
                    </>
                } */}

                

                <div style={{display:"flex", borderTop:"1px solid #eee", background:"#f9f9f9", justifyContent:"end", gap:5, padding:"15px 20px"}}>
                    <button onClick={(d) => setOpen(false)} className='btn gray'>{t("cancel")}</button>
                    <button onClick={save} className='btn green'>{t("add")}</button>

                </div>
            </div>

            

        </div>
    );
}